<template>
    <div class="icon-title-wrap">
        <div class="icon-title-inner">
            <h2 class="title">{{info.title}}</h2>
            <b-img v-if="info.src" :src="info.src" fluid></b-img>
        </div>
    </div>
</template>

<script>
export default {
    props: ["info"]
}
</script>

<style lang="scss">
    .icon-title {
        &-wrap{
            .title {
                color: $color-main;
                font-weight: 400;
                font-size: 36px !important;
            }
            img {
                margin-right: 40px;
                max-width: 65px;
                margin-left: 1rem;
            }
        }
        &-inner {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            position: relative;
            margin-bottom: 1.5rem;

            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0px;
                width: 95%;
                height: 3px;
                background-color: $color-main;
            }
        }
    }
</style>